"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.claimUploadValidationSchema = exports.claimsValidationSchema = exports.claimValidationSchema = void 0;
const yup_1 = require("yup");
const yup_rules_eth_1 = require("@dzambalaorg/yup-rules-eth");
const constants_1 = require("@dzambalaorg/constants");
const types_1 = require("@framework/types");
exports.claimValidationSchema = (0, yup_1.object)().shape({
    account: yup_rules_eth_1.addressValidationSchema,
    tokenType: (0, yup_1.mixed)().oneOf(Object.values(types_1.TokenType)).required("form.validations.valueMissing"),
    address: yup_rules_eth_1.addressValidationSchema,
    templateId: (0, yup_1.number)()
        .required("form.validations.valueMissing")
        .integer("form.validations.badInput")
        .min(0, "form.validations.rangeUnderflow"),
    amount: yup_rules_eth_1.bigNumberValidationSchema,
    endTimestamp: (0, yup_1.string)()
        .matches(constants_1.reISO8601, "form.validations.patternMismatch")
        .required("form.validations.valueMissing")
        .test("is-valid", "form.validations.rangeUnderflow", (value) => {
        if (!value) {
            return false;
        }
        if (value === new Date(0).toISOString()) {
            return true;
        }
        return new Date(value).getTime() > new Date().getTime();
    }),
});
exports.claimsValidationSchema = (0, yup_1.object)().shape({
    claims: (0, yup_1.array)().of(exports.claimValidationSchema).required("form.validations.valueMissing"),
});
exports.claimUploadValidationSchema = (0, yup_1.object)().shape({
    files: (0, yup_1.array)().min(1, "form.validations.valueMissing"),
});
//# sourceMappingURL=validation.js.map